export default __webpack_public_path__ + "static/betterlivestopbanner-4fa131c7bed2986dcadfb86f3467e6e0.png";